import { FaFacebook, FaLinkedin, FaPhoneAlt } from "react-icons/fa";

const SupportSection = () => {
  const teamMembers = [
    {
      name: "Songit Mia",
      role: "Support Executive",
      description:
        "Netfee is the software with Possibilities and Songit Mia is working as a Senior Executive to achieve higher goals.",
      imgSrc: "/images/songit.jpg",
      socialLink: [
        {
          name: "Mobile",
          icon: <FaPhoneAlt />,
          src: "01896192221",
        },
        {
          name: "Facebook",
          icon: <FaFacebook />,
          src: "https://www.facebook.com/md.sohag.rana.561548/",
        },
      ],
    },
    {
      name: "Ibnul Zarrah",
      role: "Support Executive",
      description:
        "Ibnul Zarrah has been serving in the marketing team with confidence as well as providing technical support.",
      imgSrc: "/images/ibnul.png",
      socialLink: [
        {
          name: "Mobile",
          icon: <FaPhoneAlt />,
          src: "01896192293",
        },
      ],
    },
    {
      name: "Muhammad Abu Hasan",
      role: "Support Executive",
      description:
        "Netfee is the software with Possibilities and Muhammad Abu Hasan is working as a Junior Executive to achieve higher goals.",
      imgSrc: "/images/abu-hasan.png",
      socialLink: [
        {
          name: "Mobile",
          icon: <FaPhoneAlt />,
          src: "01896192225",
        },
        {
          name: "Facebook",
          icon: <FaFacebook />,
          src: "https://www.facebook.com/muhammadabuhasann",
        },
      ],
    },
    {
      name: "Sohel Rana",
      role: "Support Executive",
      description:
        "Netfee is the software with Possibilities and Sohel Rana is working as a Junior Executive to achieve higher goals.",
      imgSrc: "/images/sohel_rana.png",
      socialLink: [
        {
          name: "Mobile",
          icon: <FaPhoneAlt />,
          src: "01896192229",
        },
        {
          name: "Facebook",
          icon: <FaFacebook />,
          src: "https://www.facebook.com/tonmoy.ahamed.693547",
        },
      ],
    },
    {
      name: "Rashidul Islam",
      role: "Support Executive",
      description:
        "Netfee is a software developed by Possibilities, where Rashidul Islam is working as a Junior Executive to achieve higher goals.",
      imgSrc: "/images/Rashed-white.jpg",
      socialLink: [
        {
          name: "Mobile",
          icon: <FaPhoneAlt />,
          src: "01896192227",
        },
        // {
        //   name: "Facebook",
        //   icon: <FaFacebook />,
        //   src: "https://www.facebook.com/tonmoy.ahamed.693547",
        // },
      ],
    },
    {
      name: "Mst. Mouri Khatun",
      role: "Support Executive",
      description:
        "Netfee is a software developed by Possibilities, where Ms. Mst. Mouri Khatun is working as a Junior Executive to achieve higher goals.",
      imgSrc: "images/Mouri-Khatun.png",
      socialLink: [
        {
          name: "Mobile",
          icon: <FaPhoneAlt />,
          src: "01896192208",
        },
        // {
        //   name: "Facebook",
        //   icon: <FaFacebook />,
        //   src: "https://www.facebook.com/tonmoy.ahamed.693547",
        // },
      ],
    },
  ];

  return (
    <div className="container w-5/6 mx-auto flex flex-col md:mt-10 mt-5">
      <div className="text-center">
        <h2 className="text-4xl text-gray-700 font-bold font-extrabold">
          Our Expert Support Team
        </h2>
        <div className="border-b-4 border-fuchsia-600 w-40 mx-auto mt-2"></div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 mt-8 md:p-10">
        {teamMembers.map((member, index) => (
          <div
            key={index}
            data-aos="zoom-in"
            className="bg-white rounded-lg border-t-2 shadow-md px-5 py-6 flex flex-col items-center text-center hover:shadow-xl hover:border-fuchsia-500 support-team-card"
          >
            {/* Member Image */}
            <img
              src={member?.imgSrc}
              alt={member?.name}
              className="w-32 h-32 rounded-full border-4 shadow-xl border-fuchsia-500 mb-4"
            />

            {/* Member Info */}
            <h3 className="text-2xl font-bold text-gray-800">{member?.name}</h3>
            <h4 className="text-lg text-indigo-700 font-semibold mb-2">
              {member?.role}
            </h4>
            <p className="text-gray-600">{member?.description}</p>

            {/* Social Links */}
            <div className="mt-4 flex items-center space-x-3 flex-wrap justify-center">
              {/* Mobile Phone Number at the top */}
              {member?.socialLink &&
                member?.socialLink.map((social, index) => (
                  <>
                    {social?.name === "Mobile" && (
                      <div key={index} className="flex justify-center">
                        <a
                          href={`tel:${social?.src}`}
                          className="text-gray-700 hover:text-fuchsia-700 text-2xl flex items-center"
                          aria-label="Call Mobile"
                        >
                          <div className="mr-2">{social?.icon}</div>
                          {social?.src}
                        </a>
                      </div>
                    )}
                    {social?.name !== "Mobile" && (
                      <a
                        key={index}
                        href={social?.src}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-gray-700 hover:text-fuchsia-700 text-2xl"
                        aria-label={social?.name}
                      >
                        {social?.icon}
                      </a>
                    )}
                  </>
                ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SupportSection;
